<template>
  <div class="main">
    <div class="top" style="margin-top: 20px">
      <div class="header-solo">
        <!-- <a href="/">
                <img src="~@/assets/logo2.png" class="logo" alt="logo" />
              </a>-->
        登录您的账号
      </div>
    </div>
    <a-form id="formLogin" class="user-layout-login" ref="formLogin" :form="form" @submit="handleSubmit">
      <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick"
      >
        <a-tab-pane key="tab1" tab="账号登录">
          <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 12px" :message="errorMsg" />
          <a-form-item>
            <div style="text-align:left;font-size: 16px;font-family: Microsoft YaHei;">账号</div>
            <a-input
              size="large"
              type="text"
              placeholder="请输入账户"
              v-decorator="[
                'username',
                {
                  rules: [{ required: true, message: '请输入帐户名或邮箱地址' }, { validator: handleUsernameOrEmail }],
                  validateTrigger: 'change'
                }
              ]"
            >
              <img slot="prefix" src="/loginImg/user.png" style="width: 15px" />
              <!--<a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>-->
            </a-input>
          </a-form-item>

          <a-form-item>
            <div style="text-align:left;font-size: 16px;font-family: Microsoft YaHei;">密码</div>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="请输入密码"
              v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur' }
              ]"
            >
              <img slot="prefix" src="/loginImg/mima.png" style="width: 15px" />
            </a-input>
          </a-form-item>
          <a-row :gutter="16" v-if="isShow > 0">
            <div style="text-align:left;font-size: 16px;font-family: Microsoft YaHei;padding-left:9px;line-height:39px">
              验证码
            </div>
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="验证码"
                  v-decorator="[
                    'captcha',
                    { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
                  ]"
                >
                  <img slot="prefix" src="/loginImg/mima.png" style="width: 15px" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <img class="getCaptcha" :src="codesrc" @click="getImgCode" />
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="tab2" tab="手机号快捷登录">
          <a-form-item>
            <div style="text-align:left;font-size: 16px;font-family: Microsoft YaHei;">手机号</div>
            <a-input
              size="large"
              type="text"
              placeholder="请输入手机号"
              v-decorator="[
                'mobile',
                {
                  rules: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }],
                  validateTrigger: 'change'
                }
              ]"
            >
              <img slot="prefix" src="/loginImg/phone.png" style="width: 15px" />
            </a-input>
          </a-form-item>
          <a-row :gutter="16">
            <div style="text-align:left;font-size: 16px;font-family: Microsoft YaHei;padding-left:9px;line-height:39px">
              验证码
            </div>
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入验证码"
                  v-decorator="[
                    'captcha',
                    { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
                  ]"
                >
                  <img slot="prefix" src="/loginImg/authCode.png" style="width: 15px" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                style="color: #999999;"
                v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
              ></a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-form-item style="margin-top: 24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
          >立即登录</a-button
        >
      </a-form-item>

      <div class="user-login-other">
        <!--<span>其他登录方式</span>-->
        <!--<a>-->
        <!--<a-icon class="item-icon" type="alipay-circle"></a-icon>-->
        <!--</a>-->
        <!--<a>-->
        <!--<a-icon class="item-icon" type="taobao-circle"></a-icon>-->
        <!--</a>-->
        <!--<a>-->
        <!--<a-icon class="item-icon" type="weibo-circle"></a-icon>-->
        <!--</a>-->

        <!--          <a-checkbox v-decorator="['rememberMe']" v-if="false">自动登录</a-checkbox>-->
        <router-link :to="{ name: 'recover' }" class="forge-password" style="float: right;padding-bottom:24px"
          >忘记密码</router-link
        >
      </div>
    </a-form>

    <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"
    ></two-step-captcha>
  </div>
</template>

<script>
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
// eslint-disable-next-line no-unused-vars
import md5 from 'md5'
// eslint-disable-next-line no-unused-vars
import { getSmsCaptcha, get2step, imgcode } from '@/api/login'
import { sendIdCode, byPhonenumLogin } from '../../api/login'

export default {
  components: {
    TwoStepCaptcha
  },
  data() {
    return {
      codesrc: null,
      randomStr: null,
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      isLoginError: false,
      errorMsg: '',
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      num: 0,
      isShow: 0,
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      }
    }
  },
  created() {
    // get2step({ })
    //   .then(res => {
    //     this.requiredTwoStepCaptcha = res.result.stepCode
    //   })
    //   .catch(() => {
    //     this.requiredTwoStepCaptcha = false
    //   })
    // this.requiredTwoStepCaptcha = true
    this.getImgCode()
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'LoginByPhone']),
    // 密码正则表达式
    // isPwd(rule, value, callback) {
    //   const pwdRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z/*\-+.~!@#$%^&*(),?`<>;':"]{6,12}$/
    //   if (value && !pwdRegex.test(value)) {
    //     callback(new Error('请输入6到12位(至少包含字母，数字，特殊符号任意两种)'))
    //   } else if (value == undefined || value.length == 0) {
    //     callback(new Error('请输入密码'))
    //   } else {
    //     callback()
    //   }
    // },
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login,
        LoginByPhone
      } = this
      state.loginBtn = true
      this.num++
      console.log(this.num)
      if (this.num == 1) {
        this.status = '1'
      } else {
        this.status = '0'
      }
      const validateFieldsKey = customActiveKey === 'tab1' ? ['username', 'password', 'captcha'] : ['mobile', 'captcha']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          console.log('login form', values)
          const loginParams = { ...values }
          delete loginParams.username
          loginParams[!state.loginType ? 'email' : 'username'] = values.username
          // loginParams.password = md5(values.password)
          loginParams.randomStr = this.randomStr
          if (validateFieldsKey.length === 2) {
            LoginByPhone(loginParams)
              .then(res => this.loginSuccess(res))
              .catch(err => this.requestFailed(err))
              .finally(() => {
                state.loginBtn = false
              })
          } else {
            loginParams.status = this.status
            Login(loginParams)
              .then(res => {
                console.log(res)
                if (res.code == 500) {
                  this.isShow++
                }
                this.loginSuccess(res)
              })
              .catch(err => this.requestFailed(err))
              .finally(() => {
                state.loginBtn = false
              })
          }
        } else {
          this.isShow++
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    getCaptcha(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this

      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          sendIdCode({ mobile: values.mobile })
            .then(res => {
              if (res.code === 0) {
                this.$message.success('验证码获取成功')
              } else if (res.code == 500) {
                this.$message.error(res.msg)
              }
              setTimeout(hide, 2500)
            })
            .catch(res => {
              this.$message.error(res.msg)
            })
        }
      })
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    async getImgCode() {
      await imgcode().then(res => {
        const raw = res.data
        const { randomstr } = res.headers
        this.randomStr = randomstr
        this.codesrc = URL.createObjectURL(raw)
      })
    },
    loginSuccess(res) {
      if (res.code === 0) {
        this.$router.push({ name: 'dashboard' }, () => {
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        })
        this.isLoginError = false
      } else {
        this.requestFailed(res)
      }
    },
    requestFailed(err) {
      // console.log('err',err)
      this.isShow++
      this.isLoginError = true
      this.getImgCode()
      this.errorMsg = ((err.response || {}).data || {}).msg || err.msg || '请求出现错误，请稍后再试'
      this.$notification['error']({
        message: '错误',
        description: this.errorMsg,
        duration: 4
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header-solo {
  height: 44px;
  line-height: 44px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #1f2e4d;
}
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;
    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }
  }
}
</style>
